import {StyleSheet, css} from 'aphrodite';
import React from 'react';

import {GetAnalysisFile} from 'analysis-tool/AnalysisTypes';
import SignedExtFileURLProxy from 'external-files/SignedExtFileURLProxy';
import ErrorBanner from 'ui-library/banners/ErrorBanner';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

interface ExternalFileImageProps {
  file: GetAnalysisFile;
}

/** @package */
export default function ExternalFileImage(props: ExternalFileImageProps): JSX.Element {
  return (
    <SignedExtFileURLProxy
      externalFileId={props.file.externalFileId!}
      url={props.file.downloadUrl!}
      renderWithSignedURL={(signedURL) => {
        if (signedURL === undefined) {
          return <CenteredHorizontalThrobber />;
        } else if (signedURL == null) {
          return <ErrorBanner>Error loading image.</ErrorBanner>;
        } else {
          return (
            <div className={css(styles.wrapper)}>
              <img className={css(styles.image)} src={signedURL} />
            </div>
          );
        }
      }}
      owningEntityApiId={props.file.id}
    />
  );
}

const styles = StyleSheet.create({
  wrapper: {
    margin: 8,
    textAlign: 'center',
    height: 'fill-available',
  },
  image: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
});
